export const Cookie = {
  getLocalCookie() {
    return document.cookie.split(';')
      .map(v => v.split('='))
      .reduce((acc, v) => {
        if (v[1] && v[1]?.trim()) acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
        return acc;
      }, {})
  },

  setLocalCookie(key, value, expiration) {
    let domain = window.location.host.replace(/^[^.]+\./, '.')
    domain = domain?.split(':')[0]
    document.cookie = `${key}=${value}; expires=${expiration}; path=/; domain=${domain}`
  },
  getMainDomain(url) {
    try {
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = `https://${url}`
      }
      url = (new URL(url)).hostname
    } catch(e) {
      console.error(e)
    }
    let domain = url.replace(/^[^.]+\./, '.')
    domain = domain?.split(':')[0]
    return domain
  }
}